import { BaseModal } from './baseModal'
import { createSelectors } from '../utils/selectorUtils';
import { createLogger } from '../utils/debugLogger';
const l = createLogger('ModalDuration.js');

export class ModalDuration extends BaseModal {
    static Selectors = createSelectors({
        INPUT: {
            SELECTED: `data-ts-cb-duration`,
            DURATION_RANGE: `data-ts-cb-duration-range`
        }
    });

    static Config = {
        QUERY_STRING_KEY: 'filterdurations'
    }

    constructor(modalName, queryStringManager = null) {
        super(modalName, queryStringManager);

        const parentLoadModalContent = this.loadModalContent.bind(this);

        this.loadModalContent = async (evt) => {
            l.log('ModalDuration: Pre-load processing');

            // Call parent method using stored reference
            await parentLoadModalContent.call(this, evt);

            if (!this.isLoaded) {
                l.log(`${this.modalName}: base not loaded`);
                return;
            }

            // Duration Range CB
            this.attachHandler(
                'durationRange',
                (rangeCb) => {
                    l.log('Add durationRange clicked', rangeCb.target.checked);
                    const range = rangeCb.target.dataset.tsCbDurationRange.split('-');
                    const min = Number(range[0]);
                    const max = Number(range[1]);

                    document.querySelectorAll(this.constructor.Selectors.INPUT.SELECTED)
                        .forEach((durationCb) => {
                         
                            const dataVal = Number(durationCb.dataset.tsCbDuration);
                            if (dataVal >= min && dataVal <= max && !durationCb.parentElement.classList.contains('-is-disabled')) {
                                durationCb.checked = rangeCb.target.checked;
                            }
                    });

                },
                `${this.constructor.Selectors.INPUT.DURATION_RANGE}`
            );
        };

        const parentclearSelected = this.clearSelected.bind(this);
        this.clearSelected = () => {
            parentclearSelected();
            l.log(`${this.modalName}: custom clear`);

            //Uncheck all duration range checkboxes
            document.querySelectorAll(this.constructor.Selectors.INPUT.DURATION_RANGE)
                .forEach(cb => {
                    cb.checked = false;
                });
        }
    }

    // Now we have to use the factory method
    static createModal(queryStringManager) {
        return BaseModal.create.call(this, 'ModalDuration', queryStringManager);
    }
}
